import React from 'react';
import PropTypes from 'prop-types';
import css from './Table.module.scss';
import TableContext from './TableContext';

const Table = ({
  children,
  className = '',
  cellAlign = 'left',
  style,
  scrollable = false,
  compact = false
}) => {
  const tableElement = (
    <TableContext.Provider value={{cellAlign}}>
      <table
        className={`${css.table} ${css[`align-${cellAlign}`] || ''} ${compact ? css.compact : ''} ${className}`.trim()}
        style={style}
      >
        {children}
      </table>
    </TableContext.Provider>
  );

  if (scrollable) {
    return (
      <div className={css.scrollableTableWrapper}>
        {tableElement}
      </div>
    );
  }

  return tableElement;
};

Table.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  cellAlign: PropTypes.oneOf(['left', 'center', 'right']),
  style: PropTypes.object,
  scrollable: PropTypes.bool,
  compact: PropTypes.bool
};

export default Table; 
